import React from 'react';

export const layoutContent = {
  header: {
    logo: '',
    nav: [
      {
        type: 'individuals',
        linkName: 'About Us',
        linkTo: '/about-us#top',
        submenu: {
          title: 'About Us',
          desc: 'It is our mission to ensure accurate, timely, comprehensive and validated analytical results to patients and healthcare providers across the globe.',
          cta: {
            href: 'tel:+12145509888',
            phone: '(214) 550-9888',
            slogan: 'We can assist you:',
          },
          links: [
            {
              type: 'internal_link',
              linkName: 'Our Mission',
              linkTo: '/about-us#top',
            },
            {
              type: 'internal_link',
              linkName: 'Meet the Team',
              linkTo: '/about-us#meet-the-team',
            },
          ],
        },
      },
      {
        type: 'providers',
        linkName: 'For Providers',
        linkTo: '/genomics/providers/cancer',
        submenu: {
          title: 'Providers',
          desc: null,
          cta: {
            href: 'tel:+12145509888',
            phone: '(214) 550-9888',
            slogan: 'We can assist you:',
          },
          links: [
            {
              type: 'internal_link', // GOES TO A PAGE INSIDE THE DOMAIN
              linkName: 'Hereditary Cancer',
              linkTo: '/genomics/providers/cancer',
            },
            {
              type: 'internal_link', // GOES TO A PAGE FROM A DIFFERENT DOMAIN
              linkName: 'Pharmacogenomics',
              linkTo: '/genomics/providers/pharmacogenomics',
            },
            {
              type: 'btn',
              linkName: 'Request a Test Kit',
              linkTo: '/order-test/providers',
            },
          ],
        },
      },
      {
        type: 'individuals',
        linkName: 'For Patients',
        linkTo: '/genomics/cancer',
        submenu: {
          title: 'Patients',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          cta: {
            href: 'tel:+12145509888',
            phone: '(214) 550-9888',
            slogan: 'We can assist you:',
          },
          links: [
            {
              type: 'internal_link',
              linkName: 'Pharmacogenomics',
              linkTo: '/genomics/pharmacogenomics',
            },
            {
              type: 'internal_link',
              linkName: 'Hereditary Cancer Testing',
              linkTo: '/genomics/cancer',
            },
            {
              type: 'btn',
              linkName: 'Request a Test Kit',
              linkTo: '/order-test/individuals',
            },
          ],
        },
      },
      {
        type: 'individuals',
        linkName: 'Contact Us',
        linkTo: '/contact#top',
        submenu: {
          title: 'Contact Us',
          desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          cta: {
            href: 'tel:+12145509888',
            phone: '(214) 550-9888',
            slogan: 'We can assist you:',
          },
          links: [
            {
              type: 'internal_link',
              linkName: 'Contact Us Today!',
              linkTo: '/contact#top',
            },
            {
              type: 'internal_link',
              linkName: 'Write Us a Message',
              linkTo: '/contact#write-us-a-message',
            },
          ],
        },
      },
    ],
  },

  footer: {
    items: [
      {
        title: 'About Us',
        links: [
          {
            type: 'internal_link',
            linkTo: '/about-us#top',
            linkName: 'Our Mission',
          },
          {
            type: 'internal_link',
            linkTo: '/about-us#meet-the-team',
            linkName: 'Meet The Team',
          },
        ],
      },
      {
        title: 'For Providers',
        links: [
          {
            type: 'internal_link', // GOES TO A PAGE INSIDE THE DOMAIN
            linkName: 'Hereditary Cancer',
            linkTo: '/genomics/providers/cancer',
          },
          {
            type: 'internal_link', // GOES TO A PAGE FROM A DIFFERENT DOMAIN
            linkName: 'Pharmacogenomics',
            linkTo: '/genomics/providers/pharmacogenomics',
          },
        ],
      },
      {
        title: 'For Patients',
        links: [
          {
            type: 'internal_link',
            linkTo: '/genomics/pharmacogenomics',
            linkName: 'Pharmacogenomics',
          },
          {
            type: 'internal_link',
            linkTo: '/genomics/cancer',
            linkName: 'Hereditary Cancer Testing',
          },
        ],
      },
      {
        socialLinks: true,
        title: 'Contact Us',
        links: [
          {
            type: 'internal_link',
            linkTo: '/contact#top',
            linkName: 'Contact Us',
          },
          {
            type: 'internal_link',
            linkTo: '/contact#write-us-a-message',
            linkName: 'Write Us A Message',
          },
        ],
      },
    ],
  },
};
